import { Provider } from 'react-redux';
import AppRouter from './modules/navigation/appRouter';
import StopUser from './modules/general/stopUser';
import { useEffect } from 'react';
import axiosInstance from './modules/general/axiosInstance';
import { setPendingCount } from './modules/general/actions';

import './styles/Main.css';

function App(props) {

  useEffect(() => {
    if (typeof Notification !== 'undefined' && Notification.permission === 'default') {
      Notification.requestPermission();
    }

    if (!localStorage.getItem('count_pending_approve')) {
      localStorage.setItem('count_pending_approve', 0);
    }

    const intervalId = setInterval(() => {
      const state = props.store.getState();
      const roles = state.roles || [];
      const canApprove = roles.includes('customer_approver') || roles.includes('provider_approver');
      if (state.isLoggedIn && canApprove) {
        getCountPendingOrders();
      }
    }, 90000);

    return () => clearInterval(intervalId);
  }, []);

  const getCountPendingOrders = async () => {
    try {
      const response = await axiosInstance.get('/orders/pending-count');
      const count = parseInt(response.data) || 0;

      props.store.dispatch(setPendingCount(count));

      if (count <= 0) {
        localStorage.setItem('count_pending_approve', 0);
        return;
      }

      const previous = parseInt(localStorage.getItem('count_pending_approve')) || 0;
      if (count > previous && typeof Notification !== 'undefined' && Notification.permission === 'granted') {
        new Notification('Notificación Abi', {
          body: `Tienes ${count} pedido${count > 1 ? 's' : ''} por aprobar.`,
          icon: `${process.env.PUBLIC_URL || ''}/logo192.png`,
        });
      }

      localStorage.setItem('count_pending_approve', count);
    } catch (e) {
      console.error('Error al obtener el conteo de pedidos pendientes:', e);
    }
  };

  return (
    <Provider store={props.store}>
      <AppRouter />
      <StopUser />
    </Provider>
  );
}

export default App;
